$(document).on('mouseover', '.mh-nav__item', function(){
    $('.mh-context-menu__drop-down').removeClass('active');

    if($('.mh-navbar').css('position') != 'fixed'){
        $(this).find('.mh-nav__collapse').addClass('active');
    }
});
$(document).on('mouseout', '.mh-nav__item', function () {
        if ($('.mh-navbar').css('position') != 'fixed') {
            $(this).find('.mh-nav__collapse').removeClass('active');
        }
});